import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryArea,
  VictoryLine,
  VictoryScatter,
  VictoryTheme,
  VictoryTooltip,
  VictoryVoronoiContainer
} from 'victory'
import { blue, brown, red } from '@material-ui/core/colors'

class AreaChart extends Component {
  constructor (props) {
    super(props)
    const { datetime } = this.props
    this.state = {
      brushDomain: { x: [datetime, datetime + 104000] },
      // externalMutations: [
      //   {
      //     childName: "scatter",
      //     target: ["data"],
      //     eventKey: "all",
      //     mutation: (props) => {
      //       // props.datum.TIMESTAMP === '2017-05-26T00:00:00Z' ? console.log(props.datum.TIMESTAMP) : null
      //       const selected = props.datum.TIMESTAMP === '2017-05-26T00:00:00Z'

      //       const style = { data: { fill: 'blue' } }
      //       return props.style = style
      //     },
      //     callback: this.removeMutation.bind(this)
      //   }
      // ]
    }
  }

  removeMutation() {
    this.setState({
      externalMutations: undefined
    });
  }

  clearClicks() {
    this.setState({
      externalMutations: [
        {
          childName: "Bar-1",
          target: ["data"],
          eventKey: "all",
          mutation: (props) => null,
          callback: this.removeMutation.bind(this)
        }
      ]
    });
  }

  
  handleMouseEnter = (event, data) => {
    const { handleMouseEnter } = this.props
    handleMouseEnter(event, data)
  }

  handleMouseLeave = (event, data) => {
    const { handleMouseLeave } = this.props
    handleMouseLeave(event, data)
  }

  handleClick = (event, data) => {
    const { handleClick } = this.props

    handleClick(event, data)
  }

  

  render () {
    const {
      data,
      x,
      y,
          xAxis,
      datetime,
      uuidsHighlighted,
      chartStyles,
          chartLabels,
      tickFormat,
      labels,
      minY,
      maxY,
      interpolation,
      offsetY,
      baseline,
      thresholdMin,
      timestamp,
      animate
    } = this.props
    // const { externalMutations } = this.state
    const time = datetime ? new Date(datetime).toISOString() : null
    // console.log(datetime, datetime)
    // console.log(time, time)
    
    return (
      <div>
        <svg style={{ height: '0', width: '0' }}>
        <defs>
          <pattern id="pattern" x="1px" y="1px" width="2" height="2" patternUnits="userSpaceOnUse" style={{fill: blue[500]}}>
            <circle id="ptnCircle" cx="1" cy="1" r="1" style={{stroke: 'none', fill: brown[500]}} />
          </pattern>
        </defs>
        </svg>
      <VictoryChart
        animate={animate}
        scale={{ x: 'time' }}
        theme={VictoryTheme.material}
        padding={{ bottom: 50, top: offsetY, left: 45, right: 10 }}
        width={600}
        height={300}
        domainPadding={{ x: 10, y: 25 }}
        style={{ parent: { cursor: 'pointer' } }}
        containerComponent={
            <VictoryVoronoiContainer
                />
            }
            >

        <VictoryAxis dependentAxis tickFormat={tickFormat}/>
        <VictoryAxis scale={{ x: 'time' }} orientation='top' offsetY={offsetY}/>
        <VictoryArea
          data={data}
          x={x}
          y={y}
          y0={() => maxY > baseline ? maxY : baseline}
          interpolation={interpolation}
          style={{ data: { fill: blue[100], opacity: 1 } }}
          labelComponent={<VictoryTooltip />}
          labels={labels}
          />            
        <VictoryLine
          data={data}
          x={x}
          y={() => baseline}
          style={{
            data: {
              strokeWidth: 1,
              strokeDasharray: '1, 1'
            }
          }}          
          />
        <VictoryArea
          data={data}
          x={x}
          y={y}
          y0={() => minY < thresholdMin ? minY : thresholdMin}
          interpolation={interpolation}
          style={{ data: { fill: brown[500], opacity: 1 } }}
          />          
          <VictoryLine
            data={data}
            x={x}
            y={() => thresholdMin}
            style={{
              data: {
                strokeWidth: 1,
                strokeDasharray: '1, 1',
                stroke: red[700]
              }
            }}
            />
            <VictoryScatter
              name='scatter'
              data={data}
              x={x}
              y={y}
              size={5}
              style={{ data: { fill: 'tomato', opacity: 1 } }}              
              events={[
                {
                  target: 'data',
                  eventHandlers: {
                    onClick: this.handleClick
                  }
                }
              ]}
              />
      </VictoryChart>
      </div>
    )
  }
}

const handleDefault = () => null

AreaChart.defaultProps = {
  handleMouseEnter: handleDefault,
  handleMouseLeave: handleDefault,
  handleZoomToObject: handleDefault,
  handleClick: handleDefault,
  xAxisProps: {},
  yAxisProps: {},
  tickFormat: null,
  labels: d => d.y,
  interpoloation: 'monotoneX',
  offsetY: 25,
  baseline: 0,
  thresholdMin: -.03,
  timestamp: '2017-05-26T00:00:00Z',
  datetime: null,
  animate: true,
  externalMutations: {}
}
export default AreaChart



// WEBPACK FOOTER //
// ./src/charts/AreaChart.js